import { render, staticRenderFns } from "./Favourites.vue?vue&type=template&id=93dd1bca&scoped=true"
import script from "./Favourites.vue?vue&type=script&lang=js"
export * from "./Favourites.vue?vue&type=script&lang=js"
import style0 from "./Favourites.vue?vue&type=style&index=0&id=93dd1bca&prod&lang=css"
import style1 from "./Favourites.vue?vue&type=style&index=1&id=93dd1bca&prod&scoped=true&lang=css"
import style2 from "./Favourites.vue?vue&type=style&index=2&id=93dd1bca&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93dd1bca",
  null
  
)

export default component.exports